// Author Liu Cui Cui
// Date 2024-03-19 18:17:44

class SithMesTpmTsdOpcConfigTtc {
constructor({
        id = null,
        ttcEocId = '',
        ttcEocName = '',
        ttcWorkshopId = '',
        ttcDeviceId = '',
        ttcInterfaceName = '',
        ttcEntityName = '',
        ttcFieldName = '',
        ttcFieldDesc = '',
        ttcUpperLimit = '',
        ttcLowerLimit = '',
        ttcSeq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ttcEocId = ttcEocId;
    this.ttcEocName = ttcEocName;
    this.ttcWorkshopId = ttcWorkshopId;
    this.ttcDeviceId = ttcDeviceId;
    this.ttcInterfaceName = ttcInterfaceName;
    this.ttcEntityName = ttcEntityName;
    this.ttcFieldName = ttcFieldName;
    this.ttcFieldDesc = ttcFieldDesc;
    this.ttcUpperLimit = ttcUpperLimit;
    this.ttcLowerLimit = ttcLowerLimit;
    this.ttcSeq = ttcSeq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesTpmTsdOpcConfigTtc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEocId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcEocId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEocName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcEocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcWorkshopId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcWorkshopId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcDeviceId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcDeviceId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcDeviceCode',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcInterfaceName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcInterfaceName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEntityName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcEntityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcFieldName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcFieldName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcFieldDesc',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcFieldDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcUpperLimit',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcUpperLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcLowerLimit',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcLowerLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcSeq',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.ttcSeq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    ttcEocIdFilter : '',
    ttcEocNameFilter : '',
    ttcWorkshopIdFilter : '',
    ttcDeviceIdFilter : '',
    ttcInterfaceNameFilter : '',
    ttcEntityNameFilter : '',
    ttcFieldNameFilter : '',
    ttcFieldDescFilter : '',
    ttcUpperLimitFilter : '',
    ttcLowerLimitFilter : '',
    ttcSeqFilter : '',
    remarkFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ttcEocIdFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcEocId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEocNameFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcEocName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'com.siemens.mmf.em.base.opcClient.common.entity.EmOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"ttcEocId":"id"}'
                }
        },
        {
        key: 'ttcWorkshopIdFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcWorkshopId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcDeviceIdFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcDeviceId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcInterfaceNameFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcInterfaceName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEntityNameFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcEntityName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldNameFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcFieldName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldDescFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcFieldDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcUpperLimitFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcUpperLimit',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcLowerLimitFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcLowerLimit',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcSeqFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.ttcSeq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.filter.remark',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'ttcEocId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcEocId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEocName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcEocName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"ttcEocId":"id"}'
                }
        },
        {
        key: 'ttcWorkshopId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcWorkshopId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcDeviceId',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcDeviceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"remark":"code"}'
                }
        },
        {
        key: 'ttcInterfaceName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcInterfaceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEntityName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcEntityName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldName',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcFieldName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldDesc',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcFieldDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcUpperLimit',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcUpperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcLowerLimit',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcLowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcSeq',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.ttcSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmTsdOpcConfigTtc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesTpmTsdOpcConfigTtc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
